import { layoutModeTokens, useLayoutMode } from '@/ui/layouts/layoutMode';
import { Box } from '@/ui/primitives';
import { s } from '../../theme/tokens';
import type { SpacingToken } from '@/theme/tokens';
import type { PropsWithChildren, ReactElement, ReactNode } from 'react';

type SectionProps = PropsWithChildren<{
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  gap?: SpacingToken;
  paddingY?: SpacingToken;
  className?: string;
}>;

export const Section = ({
  title,
  subtitle,
  actions,
  children,
  gap,
  paddingY = 'lg',
  className,
}: SectionProps): ReactElement => {
  const layoutMode = useLayoutMode();
  const isCompact = layoutMode === layoutModeTokens.compact;
  const hasHeader = [title, subtitle, actions].some(Boolean);
  const content = gap ? <Box sx={{ display: 'grid', gap: s(gap) }}>{children}</Box> : children;

  return (
    <Box
      className={className ? `flow-section-enter ${className}` : 'flow-section-enter'}
      sx={{ paddingY: s(paddingY) }}
    >
      {hasHeader ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: isCompact ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: isCompact ? 'flex-start' : 'center',
            gap: s('sm'),
            marginBottom: s('md'),
          }}
        >
          <Box>
            {title}
            {subtitle ? <Box sx={{ color: 'text.secondary' }}>{subtitle}</Box> : null}
          </Box>
          {actions ? <Box>{actions}</Box> : null}
        </Box>
      ) : null}
      {content}
    </Box>
  );
};
